import { render, staticRenderFns } from "./date-nav.vue?vue&type=template&id=2ce3a552&"
import script from "./date-nav.vue?vue&type=script&lang=ts&"
export * from "./date-nav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce3a552')) {
      api.createRecord('2ce3a552', component.options)
    } else {
      api.reload('2ce3a552', component.options)
    }
    module.hot.accept("./date-nav.vue?vue&type=template&id=2ce3a552&", function () {
      api.rerender('2ce3a552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/date-nav.vue"
export default component.exports